/* ============================================================
   BAUR VERSANDHAUS — Herbst 2026
   1) Größenassistent  2) Warenkorb-Mengenrabatt-Fortschritt
   3) Footer-Akkordeon (mobil)
   ============================================================ */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     1) GRÖSSENASSISTENT
     --------------------------------------------------------- */
  var SA = {
    root: null, data: {}, step: 0, steps: [], cfg: {},

    // Konfektions-Schwellen (Gewicht in kg) bei Referenzgröße
    tables: {
      damen: { refH: 168, per10: 4.0,
        w: [50, 56, 64, 72, 82, 95],
        labels: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],
        de:     ['32/34', '36', '38/40', '42', '44', '46/48', '50/52'] },
      herren: { refH: 180, per10: 5.0,
        w: [62, 70, 80, 90, 100, 112],
        labels: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],
        de:     ['44', '46/48', '48/50', '50/52', '54', '56', '58/60'] }
    },

    init: function () {
      this.root = document.getElementById('BvSizeAssistant');
      if (!this.root) return;
      this.cfg = {
        gender: this.root.dataset.gender || '',
        kind: this.root.dataset.kind || 'kleidung',
        category: this.root.dataset.category || ''
      };
      var self = this;
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-bv-size-open]');
        if (t) { e.preventDefault(); self.open(); }
      });
      this.root.addEventListener('click', function (e) {
        if (e.target.closest('[data-bv-sa-close]') || e.target === self.root.querySelector('.bv-sa__bd')) {
          self.close();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.root.classList.contains('is-open')) self.close();
      });
      this.build();
    },

    open: function () {
      this.root.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      this.step = 0; this.data = {}; this.render();
      var f = this.root.querySelector('.bv-sa__step.on input');
      if (f) setTimeout(function () { f.focus(); }, 260);
    },
    close: function () {
      this.root.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    },

    build: function () {
      var g = this.cfg.gender;
      this.steps = [];
      if (!g) this.steps.push('gender');
      if (this.cfg.kind === 'schuhe') {
        this.steps.push('foot', 'width');
      } else {
        this.steps.push('body', 'shape', 'fit');
      }
      this.steps.push('result');
    },

    render: function () {
      var body = this.root.querySelector('.bv-sa__body');
      var name = this.steps[this.step];
      body.innerHTML = this[name]();
      var bar = this.root.querySelector('.bv-sa__bar i');
      bar.style.width = Math.round((this.step / (this.steps.length - 1)) * 100) + '%';

      var back = this.root.querySelector('.bv-sa__back');
      back.style.visibility = this.step === 0 ? 'hidden' : 'visible';
      var next = this.root.querySelector('.bv-sa__next');
      next.style.display = (name === 'result') ? 'none' : '';
      next.textContent = (this.step === this.steps.length - 2) ? 'Größe berechnen' : 'Weiter';

      var self = this;
      body.querySelectorAll('.bv-sa__opt').forEach(function (b) {
        b.addEventListener('click', function () {
          body.querySelectorAll('.bv-sa__opt[data-k="' + b.dataset.k + '"]').forEach(function (o) {
            o.classList.remove('sel');
          });
          b.classList.add('sel');
          self.data[b.dataset.k] = b.dataset.v;
          if (b.dataset.auto === '1') setTimeout(function () { self.next(); }, 170);
        });
      });
      body.querySelectorAll('input').forEach(function (i) {
        i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.next(); } });
      });
      var addBtn = body.querySelector('[data-bv-sa-add]');
      if (addBtn) addBtn.addEventListener('click', function () { self.addToCart(addBtn.dataset.size); });
    },

    /* --- Schritte --- */
    gender: function () {
      return '<h4 class="bv-sa__q">Für wen suchen Sie eine Größe?</h4>' +
        '<p class="bv-sa__hint">Damen- und Herrengrößen fallen unterschiedlich aus. Deshalb fragen wir zuerst.</p>' +
        '<div class="bv-sa__opts bv-sa__opts--2">' +
        '<button type="button" class="bv-sa__opt" data-k="gender" data-v="damen" data-auto="1"><b>Damen</b><span>Größen XS bis 3XL</span></button>' +
        '<button type="button" class="bv-sa__opt" data-k="gender" data-v="herren" data-auto="1"><b>Herren</b><span>Größen XS bis 3XL</span></button>' +
        '</div>';
    },

    body: function () {
      return '<h4 class="bv-sa__q">Ihre Körpergröße und Ihr Gewicht</h4>' +
        '<p class="bv-sa__hint">Beides zusammen ergibt die zuverlässigste Schätzung. Ihre Angaben bleiben in Ihrem Browser und werden nicht gespeichert.</p>' +
        '<div class="bv-sa__fields">' +
        '<div class="bv-sa__f"><label for="bvH">Körpergröße</label>' +
        '<input id="bvH" type="number" inputmode="numeric" min="130" max="220" placeholder="z. B. 168" value="' + (this.data.h || '') + '"><small>in Zentimetern</small></div>' +
        '<div class="bv-sa__f"><label for="bvW">Gewicht</label>' +
        '<input id="bvW" type="number" inputmode="numeric" min="35" max="200" placeholder="z. B. 68" value="' + (this.data.w || '') + '"><small>in Kilogramm</small></div>' +
        '</div><p class="bv-sa__err">Bitte tragen Sie Größe (130–220 cm) und Gewicht (35–200 kg) ein.</p>';
    },

    shape: function () {
      return '<h4 class="bv-sa__q">Wie würden Sie Ihre Statur beschreiben?</h4>' +
        '<p class="bv-sa__hint">Bei gleichem Gewicht kann die passende Größe je nach Körperbau um eine Stufe abweichen.</p>' +
        '<div class="bv-sa__opts">' +
        '<button type="button" class="bv-sa__opt" data-k="shape" data-v="-1" data-auto="1"><b>Eher schlank</b><span>Schmale Schultern, wenig Bauchumfang</span></button>' +
        '<button type="button" class="bv-sa__opt" data-k="shape" data-v="0" data-auto="1"><b>Durchschnittlich</b><span>Ausgewogene Proportionen</span></button>' +
        '<button type="button" class="bv-sa__opt" data-k="shape" data-v="1" data-auto="1"><b>Eher kräftig</b><span>Breitere Schultern oder kräftigere Mitte</span></button>' +
        '</div>';
    },

    fit: function () {
      return '<h4 class="bv-sa__q">Wie soll das Teil sitzen?</h4>' +
        '<p class="bv-sa__hint">Manche mögen es körpernah, andere brauchen Platz für einen Pullover darunter.</p>' +
        '<div class="bv-sa__opts">' +
        '<button type="button" class="bv-sa__opt" data-k="fit" data-v="-1" data-auto="1"><b>Körpernah</b><span>Figurbetont, eng anliegend</span></button>' +
        '<button type="button" class="bv-sa__opt" data-k="fit" data-v="0" data-auto="1"><b>Normal</b><span>So, wie es gedacht ist</span></button>' +
        '<button type="button" class="bv-sa__opt" data-k="fit" data-v="1" data-auto="1"><b>Bequem</b><span>Locker, Platz zum Drüberziehen</span></button>' +
        '</div>';
    },

    foot: function () {
      return '<h4 class="bv-sa__q">Wie lang ist Ihr Fuß?</h4>' +
        '<p class="bv-sa__hint">Stellen Sie sich mit der Ferse an eine Wand, markieren Sie das Ende des längsten Zehs und messen Sie den Abstand. Falls Sie nicht messen können, tragen Sie unten Ihre gewohnte Größe ein.</p>' +
        '<div class="bv-sa__fields">' +
        '<div class="bv-sa__f"><label for="bvF">Fußlänge</label>' +
        '<input id="bvF" type="number" inputmode="decimal" step="0.1" min="19" max="34" placeholder="z. B. 24,5" value="' + (this.data.f || '') + '"><small>in Zentimetern</small></div>' +
        '<div class="bv-sa__f"><label for="bvU">oder gewohnte Größe</label>' +
        '<input id="bvU" type="number" inputmode="numeric" min="33" max="50" placeholder="z. B. 39" value="' + (this.data.u || '') + '"><small>EU-Größe</small></div>' +
        '</div><p class="bv-sa__err">Bitte tragen Sie entweder die Fußlänge oder Ihre gewohnte Größe ein.</p>';
    },

    width: function () {
      return '<h4 class="bv-sa__q">Wie breit ist Ihr Fuß?</h4>' +
        '<p class="bv-sa__hint">Bei kräftigem Spann oder breitem Ballen empfehlen wir eine halbe bis ganze Nummer mehr.</p>' +
        '<div class="bv-sa__opts">' +
        '<button type="button" class="bv-sa__opt" data-k="fw" data-v="-1" data-auto="1"><b>Eher schmal</b><span>Schuhe rutschen oft an der Ferse</span></button>' +
        '<button type="button" class="bv-sa__opt" data-k="fw" data-v="0" data-auto="1"><b>Normal</b><span>Übliche Weite</span></button>' +
        '<button type="button" class="bv-sa__opt" data-k="fw" data-v="1" data-auto="1"><b>Eher breit</b><span>Kräftiger Ballen oder hoher Spann</span></button>' +
        '</div>';
    },

    /* --- Berechnung --- */
    calc: function () {
      var g = this.cfg.gender || this.data.gender || 'damen';
      if (this.cfg.kind === 'schuhe') {
        var eu;
        if (this.data.f) {
          eu = Math.round(((parseFloat(String(this.data.f).replace(',', '.')) + 1.3) * 1.5) * 2) / 2;
        } else {
          eu = parseFloat(this.data.u);
        }
        eu += (parseInt(this.data.fw || 0, 10) > 0 ? 1 : 0);
        eu = Math.round(eu);
        var minEU = g === 'herren' ? 38 : 35;
        var maxEU = g === 'herren' ? 47 : 43;
        eu = Math.min(maxEU, Math.max(minEU, eu));
        return {
          size: String(eu),
          why: this.data.f
            ? 'Bei einer Fußlänge von ' + String(this.data.f).replace('.', ',') + ' cm' +
              (parseInt(this.data.fw || 0, 10) > 0 ? ' und einem eher breiten Fuß' : '') +
              ' passt in aller Regel Größe ' + eu + '.'
            : 'Ausgehend von Ihrer gewohnten Größe ' + this.data.u +
              (parseInt(this.data.fw || 0, 10) > 0 ? ' und einem eher breiten Fuß' : '') +
              ' empfehlen wir Größe ' + eu + '.',
          alt: 'Zwischen zwei Größen? Bei geschlossenen Stiefeln und Boots nehmen die meisten Kundinnen und Kunden die größere Nummer — besonders, wenn Sie dickere Socken tragen möchten.'
        };
      }

      var t = this.tables[g];
      var h = parseFloat(this.data.h), w = parseFloat(this.data.w);
      // Gewichtsschwellen an die Körpergröße anpassen
      var adj = ((h - t.refH) / 10) * t.per10;
      var idx = 0;
      for (var i = 0; i < t.w.length; i++) { if (w > t.w[i] + adj) idx = i + 1; }
      var base = t.labels[idx], baseDE = t.de[idx];

      var shift = parseInt(this.data.shape || 0, 10) + parseInt(this.data.fit || 0, 10);
      var cat = this.cfg.category;
      // Mäntel und Parkas werden über anderer Kleidung getragen und brauchen Luft.
      // Jacken, Blazer und Kleider fallen normal aus und bekommen keinen Aufschlag.
      if (cat === 'mantel') shift += 1;

      // zwei gleichgerichtete Wünsche verschieben höchstens eine Stufe
      if (shift > 1) shift = 1;
      if (shift < -1) shift = -1;

      var fin = Math.min(t.labels.length - 1, Math.max(0, idx + shift));
      var size = t.labels[fin], de = t.de[fin];

      var why = 'Bei ' + Math.round(h) + ' cm und ' + Math.round(w) + ' kg liegen Sie bei uns in Größe <b>' +
        base + '</b> (Konfektion ' + baseDE + ').';
      if (fin !== idx) {
        var reasons = [];
        if (parseInt(this.data.shape || 0, 10) > 0) reasons.push('Ihrer kräftigeren Statur');
        if (parseInt(this.data.shape || 0, 10) < 0) reasons.push('Ihrer schlanken Statur');
        if (parseInt(this.data.fit || 0, 10) > 0) reasons.push('Ihrem Wunsch nach einem bequemen Sitz');
        if (parseInt(this.data.fit || 0, 10) < 0) reasons.push('Ihrem Wunsch nach einem körpernahen Sitz');
        if (cat === 'mantel') reasons.push('der Trageweise über einem Pullover');
        why += ' Wegen ' + reasons.join(' und ') + ' empfehlen wir Ihnen <b>' + size +
          '</b> (Konfektion ' + de + ').';
      } else {
        why += ' Das ist auch unsere Empfehlung für Sie.';
      }

      var alt = 'Liegen Sie knapp an der Grenze? Dann greifen Sie bei Jacken, Mänteln und Strick eher zur größeren, bei Blusen, Hemden und Kleidern eher zur kleineren Größe.';
      return { size: size, why: why, alt: alt, de: de };
    },

    result: function () {
      var r = this.calc();
      this.lastSize = r.size;
      var avail = this.findOption(r.size);
      var btn = avail
        ? '<button type="button" class="bv-btn bv-btn--block" data-bv-sa-add data-size="' +
          r.size.replace(/"/g, '') + '">Größe ' + r.size + ' in den Warenkorb</button>'
        : '<p class="bv-sa__alt" style="margin-bottom:0">Größe ' + r.size +
          ' ist bei diesem Artikel gerade nicht verfügbar. Schreiben Sie uns kurz — wir sagen Ihnen, wann sie wieder da ist, oder schlagen Ihnen eine Alternative vor.</p>';

      return '<div class="bv-sa__res">' +
        '<div class="bv-sa__badge"><small>Ihre Größe</small><strong>' + r.size + '</strong></div>' +
        '<p class="bv-sa__why">' + r.why + '</p>' +
        '<p class="bv-sa__alt">' + r.alt + '</p>' +
        btn +
        '<div class="bv-sa__ok">Artikel wurde in den Warenkorb gelegt.</div>' +
        '<p class="bv-sa__mail">Unsicher? Schreiben Sie uns an <a href="mailto:info@baurversandhaus.com?subject=Pers%C3%B6nliche%20Gr%C3%B6%C3%9Fenberatung">info@baurversandhaus.com</a> — wir beraten Sie persönlich und antworten meist innerhalb weniger Stunden.</p>' +
        '</div>';
    },

    /* --- Variantenauswahl im Produktformular --- */
    findOption: function (size) {
      var wraps = document.querySelectorAll('.variant-input-wrap');
      for (var i = 0; i < wraps.length; i++) {
        var nm = (wraps[i].getAttribute('name') || '').toLowerCase();
        if (nm.indexOf('größe') === -1 && nm.indexOf('grosse') === -1 &&
            nm.indexOf('size') === -1 && nm.indexOf('gr.') === -1) continue;
        var inputs = wraps[i].querySelectorAll('input[type=radio]');
        for (var j = 0; j < inputs.length; j++) {
          var v = (inputs[j].value || '').trim().toUpperCase().replace('XXL', '2XL').replace('XXXL', '3XL');
          var want = size.toUpperCase();
          if (v === want && !inputs[j].classList.contains('disabled')) return inputs[j];
        }
      }
      return null;
    },

    addToCart: function (size) {
      var input = this.findOption(size);
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      var self = this;
      setTimeout(function () {
        var btn = document.querySelector('form[action*="/cart/add"] [data-add-to-cart], form[action*="/cart/add"] .add-to-cart');
        if (btn && !btn.disabled) {
          var ok = self.root.querySelector('.bv-sa__ok');
          if (ok) ok.classList.add('on');
          btn.click();
          setTimeout(function () { self.close(); }, 700);
        }
      }, 160);
    },

    next: function () {
      var name = this.steps[this.step];
      var err = this.root.querySelector('.bv-sa__err');
      if (name === 'body') {
        var h = parseFloat(document.getElementById('bvH').value);
        var w = parseFloat(document.getElementById('bvW').value);
        if (!(h >= 130 && h <= 220 && w >= 35 && w <= 200)) { if (err) err.classList.add('on'); return; }
        this.data.h = h; this.data.w = w;
      }
      if (name === 'foot') {
        var f = document.getElementById('bvF').value;
        var u = document.getElementById('bvU').value;
        if (!f && !u) { if (err) err.classList.add('on'); return; }
        this.data.f = f; this.data.u = u;
      }
      if ((name === 'gender' && !this.data.gender) ||
          (name === 'shape' && this.data.shape === undefined) ||
          (name === 'fit' && this.data.fit === undefined) ||
          (name === 'width' && this.data.fw === undefined)) return;

      if (this.step < this.steps.length - 1) { this.step++; this.render(); }
    },
    prev: function () { if (this.step > 0) { this.step--; this.render(); } }
  };

  /* ---------------------------------------------------------
     2) WARENKORB — Mengenrabatt-Fortschritt
     --------------------------------------------------------- */
  var TIERS = [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 },
    { qty: 4, pct: 20 }
  ];

  function renderProgress(count) {
    var els = document.querySelectorAll('[data-bv-cart-progress]');
    if (!els.length) return;
    var reached = null, nextT = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].qty) reached = TIERS[i];
      else if (!nextT) nextT = TIERS[i];
    }
    var maxQty = TIERS[TIERS.length - 1].qty;
    var pctBar = Math.min(100, Math.round((count / maxQty) * 100));

    var msg;
    if (!reached && count === 0) {
      msg = 'Ab <b>2 Artikeln</b> sparen Sie <b>10 %</b> — der Rabatt wird automatisch abgezogen.';
    } else if (nextT) {
      var miss = nextT.qty - count;
      msg = (reached ? '<b>' + reached.pct + ' % Rabatt</b> sind aktiv. ' : '') +
        'Noch <b>' + miss + ' Artikel</b> bis <b>' + nextT.pct + ' %</b>.';
    } else {
      msg = 'Bestmöglicher Rabatt erreicht: <b>' + reached.pct + ' %</b> auf Ihre Bestellung.';
    }

    els.forEach(function (el) {
      var t = el.querySelector('.bv-cart-progress__t');
      var f = el.querySelector('.bv-cart-progress__fill');
      if (t) { t.innerHTML = msg; t.classList.toggle('is-max', !nextT && !!reached); }
      if (f) f.style.width = pctBar + '%';
      el.querySelectorAll('.bv-cart-progress__s').forEach(function (s) {
        s.classList.toggle('on', count >= parseInt(s.dataset.qty, 10));
      });
    });
  }

  function readCart() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
      { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderProgress(c.item_count || 0); })
      .catch(function () {});
  }

  // Auf Warenkorb-Änderungen reagieren (fetch/XHR abfangen)
  function hookCart() {
    var of = window.fetch;
    if (of && !of.__bvHooked) {
      window.fetch = function () {
        var args = arguments;
        return of.apply(this, args).then(function (res) {
          try {
            var u = String(args[0] && args[0].url ? args[0].url : args[0] || '');
            if (/\/cart\/(add|change|update|clear)/.test(u)) setTimeout(readCart, 220);
          } catch (e) {}
          return res;
        });
      };
      window.fetch.__bvHooked = true;
    }
    var os = XMLHttpRequest.prototype.send;
    if (!os.__bvHooked) {
      var oo = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) { this.__bvUrl = u; return oo.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function () {
        var self = this;
        this.addEventListener('load', function () {
          if (/\/cart\/(add|change|update|clear)/.test(String(self.__bvUrl || ''))) setTimeout(readCart, 220);
        });
        return os.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send.__bvHooked = true;
    }
    document.addEventListener('cart:updated', readCart);
    document.addEventListener('cart:build', readCart);
    document.addEventListener('ajaxProduct:added', readCart);
  }

  /* ---------------------------------------------------------
     3) FOOTER-AKKORDEON (nur mobil)
     --------------------------------------------------------- */
  function footerAccordion() {
    document.querySelectorAll('.bv-fc:not(.bv-fc--brand) h4').forEach(function (h) {
      h.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 901px)').matches) return;
        h.parentElement.classList.toggle('open');
      });
    });
  }

  /* --- Start --- */
  function boot() {
    SA.init();
    var root = document.getElementById('BvSizeAssistant');
    if (root) {
      root.querySelector('.bv-sa__next').addEventListener('click', function () { SA.next(); });
      root.querySelector('.bv-sa__back').addEventListener('click', function () { SA.prev(); });
    }
    hookCart();
    readCart();
    footerAccordion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
